import { useCallback, useRef, useState } from 'react';

export const useInView = (threshold = 0.15, once = true) => {
  const [inView, setInView] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  const ref = useCallback(
    (node: HTMLElement | null) => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
      if (!node) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setInView(true);
            if (once) observer.disconnect();
          }
        },
        { threshold, rootMargin: '0px 0px -60px 0px' }
      );
      observer.observe(node);
      observerRef.current = observer;
    },
    [threshold, once]
  );

  return [ref, inView] as const;
};
